export const daysOptions = [
    {
        label: "Дни",
        value: "DAYS"
    },
    {
        label: "Недели",
        value: "WEEKS"
    }
]

export const waitOptions = [
    {
        label: "Часы",
        value: "HOURS"
    },
    {
        label: "Дни",
        value: "DAYS"
    },
    {
        label: "Недели",
        value: "WEEKS"
    }
]
